/**
 * Daily Deal Hero - carousel nav for the product teaser row.
 * Product add-to-cart behavior is handled globally by component-product-item.js.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.daily-deal-hero__products').forEach((wrapper) => {
    const grid = wrapper.querySelector('[data-carousel-grid]');
    const prevBtn = wrapper.querySelector('.daily-deal-hero__nav--prev');
    const nextBtn = wrapper.querySelector('.daily-deal-hero__nav--next');

    if (!grid) return;

    prevBtn?.addEventListener('click', () => {
      grid.scrollBy({ left: -240, behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      grid.scrollBy({ left: 240, behavior: 'smooth' });
    });
  });
});
